import { ActiveSelection } from 'fabric';
import { ActiveSelectionOptions } from 'fabric/src/shapes/ActiveSelection';

import { ELEMENT_FRAME_COLOR } from 'editor/src/component/EditorArea/Spread/Page/MediaElement/config';
import { LOCKED_CONTROL_VISIBILITY } from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Image/elementsConstantProps';

import type { FabricObject } from 'fabric/src/shapes/Object/FabricObject';

class CustomFabricActiveSelection extends ActiveSelection {
  constructor(objects: FabricObject[] = [], options: Partial<ActiveSelectionOptions> = {}) {
    super(objects, options);
    this.set('evented', false);
    this.setControlsVisibility(LOCKED_CONTROL_VISIBILITY);
    this.borderColor = ELEMENT_FRAME_COLOR;
    this.borderDashArray = [5, 5];
  }
}

export default CustomFabricActiveSelection;
